<template>
<div class="lotteryItems">
  <ul class="lotteryItems__listGroup">
    <li class="lotteryItems__listItem"
      v-for="item in items"
      :key="item.items_id"
      @click="showProductDetail(item)">
      <div class="media">
        <div class="media__image u-tx-center">
          <uranai-img data-clip-path-support="true" data-size="sm" size="sm" :src="item.pack_image" /><br>
          <small>当選人数：{{ item.schedule_max_order }}名様</small>
        </div>
        <div class="media__content">
          <strong class="counselorName">{{ item.name }}</strong><br>
          <strong class="u-tx-brand">当選者のみ <span v-price="item.price_taxin"></span>（税込）</strong>
          <p>当選された方にはご連絡の上、お支払い頂きます。</p>
          <div class="u-tx-right">
            <div class="btn"
              data-color="primary"
              data-size="sm"
            >抽選に応募</div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'lottery-items',
  props: {
    items: {
      type: Array,
      default: []
    }
  },
  methods: {
    showProductDetail(item) {
      this.$store.dispatch(type.SELECT_ITEM, {
        id: item.items_id,
        schedule_id: item.item_schedule_id
      })
      this.$store.dispatch(type.UPDATE_PRODUCT_DETAIL_VISIBILITY, true)
    }
  }
}</script>

<style lang="scss">
.lotteryItems {
  &__listGroup {
    list-style: none;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/LotteryItems.vue